var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-full" },
    [
      _c("ContractNavbar", {
        attrs: {
          companies: _vm.companies,
          "company-ids": _vm.companyIds,
          "contract-name": _vm.contractName,
          "contract-type": _vm.contractType,
          "contract-updated": _vm.contractUpdated,
          "contract-active": _vm.contractActive
        },
        on: {
          "update:companyIds": function($event) {
            _vm.companyIds = $event
          },
          "update:contractName": function($event) {
            _vm.contractName = $event
          },
          "update:contractType": function($event) {
            _vm.contractType = $event
          },
          "update:contractActive": function($event) {
            _vm.contractActive = $event
          },
          save: _vm.saveContract,
          preview: _vm.previewPdf
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "content flex" }, [
        _c(
          "div",
          {
            staticClass: "left-side",
            class: [
              !_vm.sidenav ? "col-md-11" : "col-md-9",
              !_vm.opened ? "col-md-12" : ""
            ]
          },
          [
            _c(
              "draggable",
              {
                attrs: { list: _vm.sections, group: "sections" },
                on: {
                  start: function($event) {
                    _vm.drag = true
                  },
                  end: _vm.dragEnd
                }
              },
              _vm._l(_vm.sections, function(section) {
                return _c(
                  "span",
                  {
                    key: section.order,
                    staticClass: "container-fluid mt-3 flex",
                    class: { hidden: !section.editor_display },
                    on: {
                      dragover: function($event) {
                        _vm.dragOver($event)
                      },
                      drop: function($event) {
                        _vm.dragDrop(section.uid, $event)
                      },
                      dragleave: function($event) {
                        _vm.dragLeave($event)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "contract-section col-md-12" }, [
                      !section.components.length
                        ? _c("span", [
                            !_vm.dragging || _vm.drag
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "flex justify-content-center h-full align-items-center"
                                  },
                                  [
                                    _vm._v(
                                      "\n                Drag a section here\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _c("span", { staticClass: "h-full" }, [
                            _c("span", [
                              _c("span", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row flex h-full justify-content-center flex-center"
                                  },
                                  _vm._l(section.components, function(
                                    component
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: component.uid,
                                        staticClass: "h-full",
                                        class: component.class
                                      },
                                      [
                                        !component.class.includes("noEditor")
                                          ? _c("text-editor", {
                                              attrs: {
                                                "section-id": section.uid,
                                                "component-id": component.uid,
                                                component: component,
                                                "contract-updated":
                                                  _vm.contractUpdated,
                                                sect: _vm.sections,
                                                "variables-array":
                                                  _vm.variablesArray,
                                                "variables-keys":
                                                  _vm.variablesKeys,
                                                drag: _vm.drag,
                                                dragging: _vm.dragging
                                              },
                                              on: {
                                                deleted: function($event) {
                                                  _vm.deleteColumn(
                                                    section.uid,
                                                    component.uid
                                                  )
                                                },
                                                update: _vm.storeHtmlToObject
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  })
                                )
                              ])
                            ])
                          ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "flex flex-column justify-content-start pl-2"
                      },
                      [
                        _c("i", { staticClass: "fa fa-arrows pointer pb-3" }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "fa fa-floppy-o pointer delete-section-ico pb-3"
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "fa fa-eye pb-3 pointer delete-section-ico",
                          attrs: { "data-toggle": "dropdown" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-menu p-3",
                            attrs: { "aria-labelledby": "showComponentButton" }
                          },
                          [
                            _c("form", [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Show section to")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "switchToggle flex justify-content-between pb-2 pt-4"
                                },
                                [
                                  _c("span", [_vm._v("Customer")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: section.customer_display,
                                        expression: "section.customer_display"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "customer" + section.uid,
                                      value: "true"
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        section.customer_display
                                      )
                                        ? _vm._i(
                                            section.customer_display,
                                            "true"
                                          ) > -1
                                        : section.customer_display
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = section.customer_display,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "true",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                section,
                                                "customer_display",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                section,
                                                "customer_display",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            section,
                                            "customer_display",
                                            $$c
                                          )
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      attrs: { for: "customer" + section.uid }
                                    },
                                    [_vm._v("Toggle")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "switchToggle flex justify-content-between"
                                },
                                [
                                  _c("span", [_vm._v("Foreman")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: section.mover_display,
                                        expression: "section.mover_display"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "foreman" + section.uid,
                                      value: "true"
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        section.mover_display
                                      )
                                        ? _vm._i(
                                            section.mover_display,
                                            "true"
                                          ) > -1
                                        : section.mover_display
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = section.mover_display,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "true",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                section,
                                                "mover_display",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                section,
                                                "mover_display",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            section,
                                            "mover_display",
                                            $$c
                                          )
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { attrs: { for: "foreman" + section.uid } },
                                    [_vm._v("Toggle")]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "fa fa-trash pointer delete-section-ico pb-3",
                          on: {
                            click: function($event) {
                              _vm.deleteContainer(section.id)
                            }
                          }
                        })
                      ]
                    )
                  ]
                )
              })
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "new-section mt-2 flex justify-content-center align-items-center mb-4 pointer",
                on: { click: _vm.createSection }
              },
              [_vm._m(0)]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.sidenav && _vm.opened
          ? _c("div", { staticClass: "right-side col-md-3 fixed" }, [
              _c(
                "span",
                {
                  staticClass: "flex justify-content-start pointer pt-3",
                  on: { click: _vm.showSidebar }
                },
                [
                  _c("i", { staticClass: "fa fa-chevron-right chevron" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v("\n          Collapse\n        ")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "container-fluid mt-3" }, [
                _c("h5", [_vm._v("Select from predefined sections")]),
                _vm._v(" "),
                _c("div", { staticClass: "row pt-3" }, [
                  _c("div", { staticClass: "col-md-4" }, [
                    _c(
                      "div",
                      {
                        staticClass: "box",
                        attrs: { draggable: "true" },
                        on: {
                          dragstart: function($event) {
                            _vm.dragStart(1, $event)
                          }
                        }
                      },
                      [_vm._m(1)]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4" }, [
                    _c(
                      "div",
                      {
                        staticClass: "box",
                        attrs: { draggable: "true" },
                        on: {
                          dragstart: function($event) {
                            _vm.dragStart(2, $event)
                          }
                        }
                      },
                      [_vm._m(2)]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4" }, [
                    _c(
                      "div",
                      {
                        staticClass: "box",
                        attrs: { draggable: "true" },
                        on: {
                          dragstart: function($event) {
                            _vm.dragStart(3, $event)
                          }
                        }
                      },
                      [_vm._m(3)]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mt-3" }, [
                    _c(
                      "div",
                      {
                        staticClass: "box",
                        attrs: { draggable: "true" },
                        on: {
                          dragstart: function($event) {
                            _vm.dragStart(4, $event)
                          }
                        }
                      },
                      [_vm._m(4)]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mt-3" }, [
                    _c(
                      "div",
                      {
                        staticClass: "box",
                        attrs: { draggable: "true" },
                        on: {
                          dragstart: function($event) {
                            _vm.dragStart(5, $event)
                          }
                        }
                      },
                      [_vm._m(5)]
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.sidenav && _vm.opened
          ? _c("div", { staticClass: "right-side col-md-1" }, [
              _c(
                "span",
                {
                  staticClass: "flex justify-content-start pointer pt-3",
                  on: { click: _vm.showSidebar }
                },
                [
                  _c("i", { staticClass: "fa fa-chevron-left chevron" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v("\n          Expand\n        ")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "container-fluid mt-3" }, [
                _c("div", { staticClass: "row pt-3" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "div",
                      {
                        staticClass: "box mb-3",
                        attrs: { draggable: "true" },
                        on: {
                          dragstart: function($event) {
                            _vm.dragStart(1, $event)
                          }
                        }
                      },
                      [_vm._m(6)]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "box mb-3",
                        attrs: { draggable: "true" },
                        on: {
                          dragstart: function($event) {
                            _vm.dragStart(2, $event)
                          }
                        }
                      },
                      [_vm._m(7)]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "box mb-3",
                        attrs: { draggable: "true" },
                        on: {
                          dragstart: function($event) {
                            _vm.dragStart(3, $event)
                          }
                        }
                      },
                      [_vm._m(8)]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "box mb-3",
                        attrs: { draggable: "true" },
                        on: {
                          dragstart: function($event) {
                            _vm.dragStart(4, $event)
                          }
                        }
                      },
                      [_vm._m(9)]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "box mb-3",
                        attrs: { draggable: "true" },
                        on: {
                          dragstart: function($event) {
                            _vm.dragStart(5, $event)
                          }
                        }
                      },
                      [_vm._m(10)]
                    )
                  ])
                ])
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "new-section-btn" }, [
      _c("i", { staticClass: "fa fa-plus-circle" }),
      _vm._v(" Add new section")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "box-1 flex justify-content-center pointer" },
      [_c("div", { staticClass: "box-column w-full" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "box-2 flex justify-content-center pointer" },
      [
        _c("div", { staticClass: "mr-1 box-column w-full" }),
        _vm._v(" "),
        _c("div", { staticClass: "box-column w-full" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "box-3 flex justify-content-center pointer" },
      [
        _c("div", { staticClass: "mr-1 box-column w-full" }),
        _vm._v(" "),
        _c("div", { staticClass: "mr-1 box-column  w-full" }),
        _vm._v(" "),
        _c("div", { staticClass: "box-column w-full" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "box-3 flex justify-content-center pointer" },
      [
        _c("div", {
          staticClass: "mr-1 box-column",
          staticStyle: { width: "66%" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "box-column", staticStyle: { width: "33%" } })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "box-3 flex justify-content-center pointer" },
      [
        _c("div", {
          staticClass: "mr-1 box-column",
          staticStyle: { width: "33%" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "box-column", staticStyle: { width: "66%" } })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "box-1 flex justify-content-center pointer" },
      [_c("div", { staticClass: "box-column w-full" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "box-2 flex justify-content-center pointer" },
      [
        _c("div", { staticClass: "mr-1 box-column w-full" }),
        _vm._v(" "),
        _c("div", { staticClass: "box-column w-full" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "box-3 flex justify-content-center pointer" },
      [
        _c("div", { staticClass: "mr-1 box-column w-full" }),
        _vm._v(" "),
        _c("div", { staticClass: "mr-1 box-column  w-full" }),
        _vm._v(" "),
        _c("div", { staticClass: "box-column w-full" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "box-3 flex justify-content-center pointer" },
      [
        _c("div", {
          staticClass: "mr-1 box-column",
          staticStyle: { width: "66%" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "box-column", staticStyle: { width: "33%" } })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "box-3 flex justify-content-center pointer" },
      [
        _c("div", {
          staticClass: "mr-1 box-column",
          staticStyle: { width: "33%" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "box-column", staticStyle: { width: "66%" } })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67367dcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67367dcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/ContractEdit.vue
// module id = null
// module chunks = 